import type {
  BoggleChallengeConfigurationBoardDistributionStep,
  BoggleChallengeConfigurationBonusStep,
  BoggleChallengeConfigurationCoreStep,
  BoggleChallengeConfigurationRolledState,
  BoggleChallengeConfigurationSpecialTileStep,
  BoggleChallengeConfigurationVowelRatioBandStep,
  BoggleChallengeCoreStepValueByDefinitionId,
} from './types'
import type { BoggleChallengeCoreDefinitionId } from '~/boggle/gameModes'
import type { BoggleChallengeBonusId } from '~/boggle/config/bonuses/types'

export function createGridSizeStep(
  resolveOptions: BoggleChallengeConfigurationCoreStep<'grid-size'>['resolveOptions'],
): BoggleChallengeConfigurationCoreStep<'grid-size'> {
  return {
    definitionId: 'grid-size',
    id: 'grid-size',
    kind: 'core',
    resolveOptions,
  }
}

export function createIntervalCountStep(
  resolveOptions: BoggleChallengeConfigurationCoreStep<'interval-count'>['resolveOptions'],
): BoggleChallengeConfigurationCoreStep<'interval-count'> {
  return {
    definitionId: 'interval-count',
    id: 'interval-count',
    kind: 'core',
    resolveOptions,
  }
}

export function createIntervalTimeStep(
  resolveOptions: BoggleChallengeConfigurationCoreStep<'interval-time'>['resolveOptions'],
): BoggleChallengeConfigurationCoreStep<'interval-time'> {
  return {
    definitionId: 'interval-time',
    id: 'interval-time',
    kind: 'core',
    resolveOptions,
  }
}

export function createMinWordLengthStep(
  resolveOptions: BoggleChallengeConfigurationCoreStep<'min-word-length'>['resolveOptions'],
): BoggleChallengeConfigurationCoreStep<'min-word-length'> {
  return {
    definitionId: 'min-word-length',
    id: 'min-word-length',
    kind: 'core',
    resolveOptions,
  }
}

export function createBonusStep(
  resolveOptions: BoggleChallengeConfigurationBonusStep['resolveOptions'],
): BoggleChallengeConfigurationBonusStep {
  return {
    id: 'bonuses',
    kind: 'bonuses',
    resolveOptions,
  }
}

export function createBoardDistributionStep(
  resolveOptions: BoggleChallengeConfigurationBoardDistributionStep['resolveOptions'],
): BoggleChallengeConfigurationBoardDistributionStep {
  return {
    id: 'board-distribution',
    kind: 'board-distribution',
    resolveOptions,
  }
}

export function createVowelRatioBandStep(
  resolveOptions: BoggleChallengeConfigurationVowelRatioBandStep['resolveOptions'],
): BoggleChallengeConfigurationVowelRatioBandStep {
  return {
    id: 'vowel-ratio-band',
    kind: 'vowel-ratio-band',
    resolveOptions,
  }
}

export function createSpecialTileStep(
  resolveEligibility: BoggleChallengeConfigurationSpecialTileStep['resolveEligibility'],
): BoggleChallengeConfigurationSpecialTileStep {
  return {
    id: 'special-tiles',
    kind: 'special-tiles',
    resolveEligibility,
  }
}

export function getCoreOptionId<TDefinitionId extends BoggleChallengeCoreDefinitionId>(
  rolledState: BoggleChallengeConfigurationRolledState,
  definitionId: TDefinitionId,
) {
  return getCoreValue(rolledState, definitionId)
}

export function getCoreValue<TDefinitionId extends BoggleChallengeCoreDefinitionId>(
  rolledState: BoggleChallengeConfigurationRolledState,
  definitionId: TDefinitionId,
): BoggleChallengeCoreStepValueByDefinitionId[TDefinitionId] | null {
  return rolledState.coreValuesByDefinitionId[definitionId] ?? null
}

export function hasBonus(
  rolledState: BoggleChallengeConfigurationRolledState,
  bonusId: BoggleChallengeBonusId,
) {
  return rolledState.bonuses.some(bonus => bonus.familyId === bonusId)
}
